import React from 'react'

import { DEFAULT_PROFILE_PIC_SRC, ALL_LANGUAGES } from './../../constants'
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share'
import { translate } from 'react-i18next'

import Modal from 'react-bootstrap-modal'
import { SocialIcon } from 'react-social-icons'
import whatsappIcon from '../../../public/img/GuruProfile/whatsapp.svg'
import copyLinkIcon from '../../../public/img/GuruProfile/copyLink.png'

class GuruProfileAbout extends React.Component {
  state = {
    isShowShareModal: false,
    isSuccess: false,
    currentLink: null
  }

  searchLanguaegs = langId => {
    return ALL_LANGUAGES.filter(lang => {
      if (lang['1'] === langId) {
        return lang.name
      }
    })
  }

  renderLanguages = () => {
    const { languages } = this.props.user.guideProfile
    if (!languages) return ''
    let string
    if (languages.length > 1) {
      const langArray = languages.map(langId => this.searchLanguaegs(langId)[0].name)
      console.log(langArray)
      string = langArray.slice(0, -1).join(', ') + ' and  ' + langArray[langArray.length - 1]
    } else {
      string = ALL_LANGUAGES[languages[0]]
    }
    return string
  }

  handleClose = () => {
    this.setState({ isShowShareModal: false })
  }

  handleShow = () => {
    this.setState({ isShowShareModal: true })
  }

  handleShare = () => {
    this.handleShow()
  }

  handleClipBoard = text => {
    document.addEventListener('copy', e => {
      e.clipboardData.setData('text/plain', text)
      e.preventDefault() // default behaviour is to copy any selected text
    })

    document.execCommand('copy')

    this.setState({
      isSuccess: true,
      currentLink: text
    })
  }

  copySuccess = () => {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: 15,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-around'
        }}
      >
        {`Link copied`}
        <code>{this.state.currentLink}</code>
      </div>
    )
  }

  renderModal = () => {
    const { t } = this.props

    return (
      <Modal
        show={this.state.isShowShareModal}
        onHide={this.handleClose}
        className="copy-modal"
        aria-labelledby="ModalHeader"
        style={{ paddingBottom: 25 }}
      >
        <Modal.Header closeButton={true}>
          <Modal.Title
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-around'
            }}
          >
            Share it with your friends
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-around',
              paddingBottom: 15
            }}
          >
            <div>
              <FacebookShareButton url={window.location.href}>
                <SocialIcon network="facebook" color="#4168AD" />
              </FacebookShareButton>
            </div>
            <div>
              <TwitterShareButton
                //title={ this.props.guruId ? `${host}/gurus/guru-profile/${this.props.guruId}` : `${host}/gurus/guru-profile/${this.props.user.id}`}
                url={window.location.href}
                hashtags={['GetTrip.Guru']}
              >
                <SocialIcon network="twitter" color="#00A2EC" />
              </TwitterShareButton>
            </div>
            <div>
              <WhatsappShareButton url={window.location.href} hashtags={['GetTrip.Guru']}>
                <img src={whatsappIcon} style={{ width: 50, height: 50 }} />
              </WhatsappShareButton>
            </div>
            <div style={{ cursor: 'pointer' }}>
              <img
                src={copyLinkIcon}
                style={{ width: 50, height: 50 }}
                onClick={() =>
                  this.props.guruId ? this.handleClipBoard(window.location.href) : this.handleClipBoard(window.location.href)
                }
              />
            </div>
          </div>

          {this.state.isSuccess && this.copySuccess()}
        </Modal.Body>
      </Modal>
    )
  }

  render() {
    const { userProfile, guideProfile } = this.props.user
    const { t } = this.props
    return (
      <div className="guru-profile__about-block">
        <div className="guru-profile__about-header">
          <img src={userProfile ? userProfile.imageAvatar.url : DEFAULT_PROFILE_PIC_SRC} className="guru-profile__avatar" alt="" />
          <div className="guru-profile__about-header-right">
            <div className="guru-profile__name-section">
              <div className="guru-profile__name">
                {userProfile.firstName} {userProfile.lastName}
              </div>
              <div className="guru-profile__description">{this.props.t('your_profile_summary_title')}</div>
            </div>
            <div className="guru-profile__header-icons">
              {/*<span className="icon-email" />*/}
              <span className="icon-share" onClick={this.handleShare} />
              <span className="icon-like" />
            </div>
          </div>
        </div>
        <div className="guru-profile__about-body">
          <div>
            <div className="guru-profile__feature reviews-bar">
              <div className="guru-profile__feature-icon rating-stars">
                <span className="icon-star-filled" />
                <span className="icon-star-filled" />
                <span className="icon-star-filled" />
                <span className="icon-star-filled" />
                <span className="icon-star-filled" />
              </div>
              <span>{this.props.user.reviewsData ? this.props.user.reviewsData.length : 0} review(s)</span>
            </div>
            <div className="guru-profile__feature">
              <div className="guru-profile__feature-icon">
                <span className="icon-language" />
              </div>
              <span>{this.renderLanguages()}</span>
            </div>
          </div>
          {/*<h4 className="guru-profile__section-title">*/}
          {/*What will you get*/}
          {/*</h4>*/}
          {/*<div>*/}
          {/*<div className="guru-profile__feature">*/}
          {/*<div className="guru-profile__feature-icon">*/}
          {/*<span className="icon-trip-plan" />*/}
          {/*</div>*/}
          {/*<span>*/}
          {/*A detailed trip plan that<br />*/}
          {/*solves all your questions*/}
          {/*</span>*/}
          {/*</div>*/}
          {/*<div className="guru-profile__feature">*/}
          {/*<div className="guru-profile__feature-icon">*/}
          {/*<span className="icon-speech-bubble" />*/}
          {/*</div>*/}
          {/*<span>*/}
          {/*Online support that<br />*/}
          {/*helps you each step of your trip*/}
          {/*</span>*/}
          {/*</div>*/}
          {/*</div>*/}
        </div>
        <div className="guru-profile__section">
          <h4 className="guru-profile__section-title">About me</h4>
          {guideProfile.aboutMyself}
        </div>
        <div className="guru-profile__categories">
          <h4 className="guru-profile__section-title">Categories</h4>
          <div>
            {this.props.user &&
              this.props.user.guideProfile.categories &&
              this.props.user.guideProfile.categories.map((categorie, index) => (
                <span key={index}>
                  {this.props.user.guideProfile.categories.length > 1
                    ? `${t(categorie)}${index < this.props.user.guideProfile.categories.length - 1 ? ',' : ''} `
                    : t(categorie)}
                </span>
              ))}
          </div>
        </div>
        {this.renderModal()}
      </div>
    )
  }
}

export default translate('categories')(GuruProfileAbout)



// WEBPACK FOOTER //
// src/components/Guide/GuideProfileAbout.jsx